<template>
  <div
    class="profile-wrapper"
    style="
      flex: 1;
      flex-direction: column;
      display: flex;
      max-width: 100%;
      height: 100vh;
    "
  >
    <el-dialog
      :visible.sync="showHistory"
      title="Modül Konfigrasyon Değişim Günlüğü"
    >
      <ul>
        <li v-for="i in configHistory">
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.currentSpeed || i.speed"
          >
            HIZ: {{ i.currentSpeed }}
            {{ i.speed }}
          </div>
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.level || i.currentLevel"
          >
            LEVEL:
            {{ i.level || i.currentLevel }}
          </div>
          <div
            style="color: white; padding: 10px 20px"
            v-if="i.mode || i.currentMode"
          >
            MODE:
            {{ i.mode || i.currentMode }}
          </div>
        </li>
      </ul>
    </el-dialog>

    <div
      style="
        display: flex;
        flex: 1;
        width: 100%;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      "
      :key="program.step_id"
      :style="{
        transform: 'scale(' + $store.state.scale + ')',
        transformOrigin: 'top center',
      }"
    >
      <h1>Gün: {{ program.step }} Adım: {{ program.order_no }}</h1>
      <GozEsnetme
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'goz-esnetme'"
      ></GozEsnetme>
      <IkiliUcluBlok
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'ikili-uclu-blok'"
      ></IkiliUcluBlok>
      <EsnekGormeAlani
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'esnek-gorme-alani'"
      ></EsnekGormeAlani>
      <GozEsnekligi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'goz-esnekligi'"
      ></GozEsnekligi>
      <GozRitim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'goz-ritim'"
      ></GozRitim>
      <AcilanNesnelerYatay
        direction="horizontal"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'acilan-nesneler-yatay'"
      ></AcilanNesnelerYatay>
      <KareGormeAlani
        direction="vertical"
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'kare-gorme-alani'"
      ></KareGormeAlani>
      <HarfSayma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'harf-sayma'"
      ></HarfSayma>
      <FarkliOlan
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'farkli-olan'"
      ></FarkliOlan>
      <KelimeAvi
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'kelime-avi'"
      ></KelimeAvi>
      <CokluFokus
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'coklu-fokus'"
      ></CokluFokus>
      <CevreFokus
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'cevre-fokus'"
      ></CevreFokus>
      <BlokOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'blok-okuma'"
      ></BlokOkuma>
      <GolgeliOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'golgeli-okuma'"
      ></GolgeliOkuma>
      <GrupOkuma
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'grup-okuma'"
      ></GrupOkuma>
      <Takistoskop
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'takistoskop'"
      ></Takistoskop>
      <ZikZak
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'zikzak'"
      ></ZikZak>
      <Siralama
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'siralama'"
      ></Siralama>
      <DuzeltBakalim
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'duzelt-bakalim'"
      ></DuzeltBakalim>
      <BenzerKelimeler
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'benzer-kelimeler'"
      ></BenzerKelimeler>
      <EsAnlamlilar
        :config="activeStepProgram"
        ref="activeModule"
        v-if="program.module.slug == 'es-anlamlilar'"
      ></EsAnlamlilar>
      <HangisiBuyuk
        :config="activeStepProgram"
        ref="activeModule"
        :getTime="getTime"
        v-if="program.module.slug == 'hangisi-buyuk'"
      ></HangisiBuyuk>
      <HizliSecim
        :config="activeStepProgram"
        ref="activeModule"
        :getTime="getTime"
        v-if="program.module.slug == 'hizli-secim'"
      ></HizliSecim>
      <HafizandaTut
        :config="activeStepProgram"
        ref="activeModule"
        :getTime="getTime"
        v-if="program.module.slug == 'hafiza-ucgeni'"
      ></HafizandaTut>
    </div>
  </div>
</template>

<script>
import GozEsnetme from "@/components/modules/GozEsnetme";
import IkiliUcluBlok from "@/components/modules/IkiliUcluBlok";
import EsnekGormeAlani from "@/components/modules/EsnekGormeAlani";
import GozEsnekligi from "@/components/modules/GozEsnekligi";
import GozRitim from "@/components/modules/GozeRitim";
import AcilanNesnelerYatay from "@/components/modules/AcilanNesnelerYatay";
import KareGormeAlani from "@/components/modules/KareGormeAlani";
import HarfSayma from "@/components/modules/HarfSayma";
import FarkliOlan from "@/components/modules/FarkliOlan";
import KelimeAvi from "@/components/modules/KelimeAvi";
import CokluFokus from "@/components/modules/CokluFokus";
import CevreFokus from "@/components/modules/CevreFokus";
import BlokOkuma from "@/components/modules/BlokOkuma";
import GolgeliOkuma from "@/components/modules/GolgeliOkuma";
import GrupOkuma from "@/components/modules/GrupOkuma";
import Takistoskop from "@/components/modules/Takistoskop";
import ZikZak from "@/components/modules/ZikZak";
import Siralama from "@/components/modules/Siralama";
import DuzeltBakalim from "@/components/modules/DuzeltBakalim";
import BenzerKelimeler from "@/components/modules/BenzerKelimeler";
import EsAnlamlilar from "@/components/modules/EsAnlamlilar";
import axios from "axios";
import HangisiBuyuk from "@/components/modules/HangisiBuyuk";
import Video from "@/components/modules/Video";
import HizliSecim from "@/components/modules/HizliSecim";
import HafizandaTut from "@/components/modules/HafizandaTut";
import $ from "jquery";
export default {
  components: {
    EsAnlamlilar,
    BenzerKelimeler,
    GozEsnetme,
    IkiliUcluBlok,
    EsnekGormeAlani,
    GozEsnekligi,
    GozRitim,
    AcilanNesnelerYatay,
    KareGormeAlani,
    HarfSayma,
    FarkliOlan,
    KelimeAvi,
    CokluFokus,
    CevreFokus,
    BlokOkuma,
    GolgeliOkuma,
    GrupOkuma,
    Takistoskop,
    ZikZak,
    Siralama,
    DuzeltBakalim,
    HangisiBuyuk,
    Video,
    HizliSecim,
    HafizandaTut,
  },
  name: "ExerciseDetail",
  data() {
    return {
      currentStep: 1,
      steps: null,
      started: false,
      interval: null,
      timer: 0,
      moment,
      height: 0,
      pause: false,
      configHistory: [],
      showHistory: false,
      videoDuration: 1,
      program: [],
      programs: [],
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getTime() {
      return this.timer;
    },
    totalDuration(time) {
      this.videoDuration = time;
    },
    next() {
      if (this.$store.state.user.tester == 1) {
        this.timer = 1;
      }
    },
    back() {
      if (this.timer > 0) {
        if (confirm(this.$t("coursedetail.confirm"))) {
          this.$router.push({ name: "Courses" });
        }
      } else {
        this.$router.push({ name: "Courses" });
      }
    },
    fullScreen(r) {
      var isInFullScreen =
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);

      var docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        if (r == true) {
          return;
        }
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    playerTimeChanged(time) {
      this.timer = time;
    },
    next() {
      if (document.getElementById("goz_esnetme")) {
        this.$message.success("Test Passed...");
        this.programs.splice(0, 1);
        this.program = this.programs[0];
        setTimeout(() => {
          this.next();
        }, 1000);
      } else {
        this.$message.error("Test Error");
      }
    },
  },
  watch: {
    "activeStep.program.module.slug": function () {
      this.pause = false;
    },
  },
  async created() {
    axios.get("course/getSteps").then((res) => {
      this.programs = res.data.data;
      this.program = this.programs[0];
      setTimeout(() => {
        this.next();
      }, 1000);
    });

    this.$root.$on("pause", (s) => {
      this.pause = s;
    });

    this.$root.$on("done", () => {
      this.pause = false;
      this.timer = 1;
    });
  },
  computed: {
    activeStepProgram() {
      var config = this.program.config;

      Object.keys(config).map((key) => {
        if (typeof config[key] === "string") {
          if (!isNaN(parseInt(config[key]))) {
            config[key] = parseInt(config[key]);
          }
        }
      });

      return config;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/StepTest.vue